import { useQueries } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';
import { queryKeys } from '../utils/queryKeys';

const fetchTickerText = async (tickerTextId) => {
  const { data, error } = await supabase
    .from("ticker_texts")
    .select("ticker_text")
    .eq("id", tickerTextId)
    .single();

  if (error) throw error;
  return data?.ticker_text;
};

const fetchLogo = async (isSmallScreen) => {
  // ID diferente según el tamaño de pantalla
  const logoId = isSmallScreen
    ? "dfb201a7-4ce2-492e-ad3d-a39eeb3022b4"  // Mobile/Tablet logo
    : "8eb58ce6-0a17-4a54-9529-a02184d977cd"; // Desktop logo

  const { data, error } = await supabase
    .from("assets")
    .select("link")
    .eq("id", logoId)
    .single();

  if (error) throw error;
  return data?.link;
};

export function useNavBar({ size, tickerTextId = 1, overrideTickerText }) {
  const isSmallScreen = ["Tablet", "Phone"].includes(size);

  const queries = useQueries({
    queries: [
      {
        // Solo ejecutar la query del ticker si no hay override
        queryKey: queryKeys.ticker.byId(tickerTextId),
        queryFn: async () => {
          try {
            return await fetchTickerText(tickerTextId);
          } catch (error) {
            throw error;
          }
        },
        enabled: !overrideTickerText,
        staleTime: 1000 * 60 * 5, // 5 minutos
      },
      {
        queryKey: queryKeys.assets.byId(isSmallScreen ? 'mobile-logo' : 'desktop-logo'),
        queryFn: async () => {
          try {
            return await fetchLogo(isSmallScreen);
          } catch (error) {
            throw error;
          }
        },
        staleTime: 1000 * 60 * 60, // 1 hora - los logos cambian con poca frecuencia
      }
    ]
  });

  const [tickerQuery, logoQuery] = queries;

  // Usar el override si está disponible, sino usar el resultado de la query
  const tickerText = overrideTickerText || tickerQuery.data || 
    "Discover the latest projects before they launch.";

  return {
    tickerText,
    logoUrl: logoQuery.data,
    isLoading: queries.some(query => query.isLoading),
    error: queries.find(query => query.error)?.error,
    // Estados adicionales para mejor control
    isFetching: queries.some(query => query.isFetching),
    isRefetching: queries.some(query => query.isRefetching)
  };
}